'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactIdSwiper = require('react-id-swiper');var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
var _reactRouter = require('react-router');
var _components = require('../../../components');
var _constants = require('../../../constants');
var _galleryParams = require('../../../galleryParams');var _galleryParams2 = _interopRequireDefault(_galleryParams);
var _formatCurrency = require('../../../utils/formatCurrency');var _formatCurrency2 = _interopRequireDefault(_formatCurrency);
var _formatSEOData = require('../../../utils/formatSEOData');
var _makeSharingUrl = require('../../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);

var _Lightbox = require('./Lightbox.scss');var styles = _interopRequireWildcard(_Lightbox);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var nisSign = '₪';var

Lightbox = function (_Component) {_inherits(Lightbox, _Component);function Lightbox() {var _temp, _this, _ret;_classCallCheck(this, Lightbox);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      currentImage: _this.props.currentImage,
      right: 0,
      shareMenuOpened: false }, _this.
















    formatPrice = function () {var _this$props =
      _this.props,translate = _this$props.translate,isRtl = _this$props.isRtl,searchOption = _this$props.searchOption,_this$props$propertyD = _this$props.propertyData,currency = _this$props$propertyD.currency,price = _this$props$propertyD.price;
      var currencySymbol = currency ?
      (0, _formatCurrency2.default)(currency) :
      nisSign;

      var currencySign = price ? currencySymbol : '';

      if (searchOption === 'forShortRent') {
        return isRtl ?
        _react2.default.createElement('span', null, price + ' ' + currencySign + '/' + translate('day')) :
        _react2.default.createElement('span', null, translate('day') + '/' + currencySign + ' ' + price);
      }

      return isRtl ?
      _react2.default.createElement('span', null, price, ' ', currencySign) :
      _react2.default.createElement('span', null, currencySign, ' ', price);
    }, _this.

    goToBack = function (event) {var _this$props2 =
      _this.props,isModal = _this$props2.isModal,isMobile = _this$props2.isMobile;
      event.preventDefault();

      if (isModal || isMobile) {
        _reactRouter.browserHistory.goBack();
      }

      _this.setState({ shareMenuOpened: false });
      _this.props.hideLightbox();
    }, _this.

    share = function () {return _this.setState(function (prevState) {return {
          shareMenuOpened: !prevState.shareMenuOpened };});}, _this.


    handleClose = function () {
      _this.setState({ shareMenuOpened: false });
      _this.props.hideLightbox();
    }, _this.

    handlePressKey = function (event) {
      if (_this.swiperRef) {
        var swiper = _this.swiperRef.swiper;
        var isRtl = _this.props.isRtl;

        if (event.code === 'ArrowRight') {
          swiper[isRtl ? 'slidePrev' : 'slideNext']();
        }

        if (event.code === 'ArrowLeft') {
          swiper[isRtl ? 'slideNext' : 'slidePrev']();
        }
      }
    }, _this.

    handleClickOutside = function (event) {
      if (
      event.target.classList.contains(styles.image) ||
      event.target.classList.contains(styles.swiperWrapper))
      {
        _this.handleClose();
      }
    }, _this.

    slideChange = function () {
      if (_this.swiperRef) {
        var index = _this.swiperRef.swiper.activeIndex;
        _this.setState({ currentImage: index });
        _this.props.changeLightboxActiveSlide && _this.props.changeLightboxActiveSlide(index);
      }
    }, _this.

    renderBackToSearch = function (id) {return (
        _react2.default.createElement('p', { onClick: _this.goToBack, className: styles.backToSearch },
          _react2.default.createElement('i', { className: 'icon icon-back-property' }),
          _this.props.translate('backToSearch')));}, _this.



    renderSave = function (id) {return (
        _react2.default.createElement('p', { className: styles.saveWrapper, onClick: _this.props.toggleFavorite },
          _react2.default.createElement('i', { className: 'icon icon-' + (_this.props.isFavorite ? 'favorite-active' : 'heart-straight') }),
          _this.props.translate('save')));}, _this.


    renderShare = function (id) {
      var sharingData = {
        sharingUrl: (0, _makeSharingUrl2.default)('/home_details/' + _this.props.id, _this.props.locale),
        sharingTitle: (0, _formatSEOData.formatPropertyTitle)(
        (0, _get2.default)(_this.props, 'propertyData'),
        (0, _get2.default)(_this.props, 'propertyData.property_type'),
        _this.props.translate('propertyDetails'),
        _this.props.locale) };


      return (
        _react2.default.createElement('div', { className: styles.shareButton },
          _react2.default.createElement('p', { className: styles.share, onClick: _this.share },
            _react2.default.createElement('i', { className: 'icon icon-export' }),
            _this.props.translate('share')),

          _this.state.shareMenuOpened && !_this.props.isMobile &&
          _react2.default.createElement('div', { className: styles.shareMenu },
            _react2.default.createElement(_components.ShareBlock, {
              sharingData: sharingData,
              isMobile: _this.props.isMobile,
              locale: _this.props.locale,
              copyLinkTitle: '' + _this.props.translate('copyLink'),
              shareTitle: '' + _this.props.translate('companyPage', 'shareTitle'),
              className: 'companySocialIcons',
              isCloseЕitle: true,
              inColumn: true,
              withSocialName: true,
              translate: _this.props.translate,
              emailTitle: sharingData.sharingTitle }))));





    }, _this.

    renderGallery = function () {var _cx;var _this$props3 =















      _this.props,isMobile = _this$props3.isMobile,isRtl = _this$props3.isRtl,propertyType = _this$props3.propertyType,locale = _this$props3.locale,toggleFavorite = _this$props3.toggleFavorite,isFavorite = _this$props3.isFavorite,isForeign = _this$props3.isForeign,isProject = _this$props3.isProject,id = _this$props3.id,searchOptionType = _this$props3.searchOptionType,videos = _this$props3.videos,vrView = _this$props3.vrView,routeData = _this$props3.routeData,isNative = _this$props3.isNative;
      var translate = _this.props.translate('propertyDetails');
      var rooms = (0, _get2.default)(_this.props, 'propertyData.additional_info.rooms');
      var toilets = (0, _get2.default)(_this.props, 'propertyData.additional_info.toilets');
      var base = (0, _get2.default)(_this.props, 'propertyData.additional_info.area.base');
      var images = (0, _get2.default)(_this.props, 'images') || [];
      var gallerySwiperParams = (0, _galleryParams2.default)({
        title: {
          nextParams: '' + _this.props.translate('nextBtn'),
          prevParams: '' + _this.props.translate('prevBtn') },

        className: 'PropertyLightboxArrow',
        isMobile: isMobile,
        isRtl: isRtl });


      return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.imgContainer, (_cx = {}, _cx[styles.projectImgContainer] = isProject, _cx)) },
          _this.props.isMobile ?
          _react2.default.createElement('div', null,
            _react2.default.createElement(_components.PropertyToolsBarMobile, {
              isNative: isNative,
              locale: locale,
              translate: _this.props.translate,
              rootTranslate: _this.props.rootTranslate,
              toggleFavorite: toggleFavorite,
              isFavorite: isFavorite,
              isForeign: isForeign,
              id: id,
              routeData: routeData,
              hideLightbox: _this.props.hideLightbox,
              withoutPrint: true,
              withoutNote: true,
              isWhite: true })) :


          _react2.default.createElement('header', { className: styles.header },
            _react2.default.createElement('div', null,
              _this.renderBackToSearch(),
              _react2.default.createElement('div', { className: styles.reportPropertyWrapper },
                _react2.default.createElement(_components.ReportProperty, {
                  key: 'reportProperty',
                  translate: _this.props.rootTranslate('reportProperty'),
                  isForeign: isForeign }))),



            _react2.default.createElement('div', { className: styles.titleWrapper },
              _react2.default.createElement('p', { className: styles.title }, _this.props.translate('gallery'))),

            _react2.default.createElement('div', null,
              _this.renderSave(),
              _this.renderShare(),
              _react2.default.createElement('button', {
                  className: styles.btnWrapper,
                  onClick: _this.handleClose,
                  title: _this.props.translate('closeBtn') },

                _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-close', styles.closeBtn) })))),




          _react2.default.createElement('div', { className: styles.swiperWrapper, onClick: _this.handleClickOutside },
            videos,
            vrView,
            !videos && !vrView &&
            _react2.default.createElement(_reactIdSwiper2.default, _extends({},
              gallerySwiperParams, {
                loop: !!images.length,
                on: { slideChange: _this.slideChange },
                ref: function ref(_ref2) {_this.swiperRef = _ref2;},
                initialSlide: _this.state.currentImage,
                noSwiping: images.length <= 1 }),

              images.map(function (_ref) {var full = _ref.full;return (
                  _react2.default.createElement('div', { className: styles.image, key: full },
                    _react2.default.createElement('img', { src: full, alt: '' })));}))),






          !isProject && _react2.default.createElement('footer', { className: styles.footer },
            _react2.default.createElement('p', { className: styles.title }, propertyType, ' ', _this.props.translate(searchOptionType)),
            _this.formatPrice(),
            _react2.default.createElement('div', null,
              '( ',
              base ? _this.props.translate('size') + ' ' + base + ', ' : '',
              rooms ? _this.props.translate('rooms') + ' ' + rooms + ', ' : '',
              toilets ? _this.props.translate('toilets') + ' ' + toilets : '',
              ' )'))));




    }, _temp), _possibleConstructorReturn(_this, _ret);}Lightbox.prototype.componentDidMount = function componentDidMount() {document.body.addEventListener('keydown', this.handlePressKey);};Lightbox.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref3) {var currentImage = _ref3.currentImage;if (currentImage !== this.props.currentImage || currentImage !== this.state.currentImage) {this.setState({ currentImage: currentImage });}};Lightbox.prototype.componentWillUnmount = function componentWillUnmount() {document.body.removeEventListener('keydown', this.handlePressKey);};Lightbox.prototype.

  render = function render() {var
    isOpen = this.props.isOpen;
    return (
      _react2.default.createElement('div', null,
        _react2.default.createElement(_components.Modal, {
            isOpen: isOpen,
            onRequestClose: this.props.hideLightbox,
            className: 'propertyLightboxModal',
            isMobile: this.props.isMobile,
            isCloseButtonInvisible: true,
            isRtl: this.props.isRtl,
            shouldCloseOnOverlayClick: false },

          this.renderGallery())));



  };return Lightbox;}(_react.Component);exports.default = Lightbox;


Lightbox.propTypes = {
  isOpen: _propTypes2.default.bool,
  isFavorite: _propTypes2.default.bool,
  images: _propTypes2.default.array,
  videos: _propTypes2.default.node,
  vrView: _propTypes2.default.node,
  currentImage: _propTypes2.default.number,
  hideLightbox: _propTypes2.default.func,
  changeLightboxActiveSlide: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  isModal: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  isProject: _propTypes2.default.bool,
  isNative: _propTypes2.default.bool,
  additionalButton: _propTypes2.default.element,
  propertyData: _propTypes2.default.object,
  searchOption: _propTypes2.default.func,
  propertyType: _propTypes2.default.string,
  searchOptionType: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  toggleFavorite: _propTypes2.default.func,
  isForeign: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  routeData: _propTypes2.default.object };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/Lightbox/Lightbox.js
// module id = 1233
// module chunks = 0